"use client";

import { Search, X } from "lucide-react";
import { useTranslations } from "next-intl";
import { useRef } from "react";
import { Button, cn, HStack, Input } from "@/ui";

interface SearchBoxProps {
  value: string;
  onValueChange: (value: string) => void;
}

/**
 * SearchBox component - Search input with clear button
 */
export const SearchBox = ({ value, onValueChange }: SearchBoxProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const navigationT = useTranslations("navigation");

  return (
    <HStack className="join relative items-center">
      <Input
        ref={inputRef}
        className="join-item sm:text-sm"
        placeholder={navigationT("search")}
        type="text"
        value={value}
        onChange={(event) => {
          onValueChange(event.target.value);
        }}
        // autoFocus
      />
      <X
        className={cn(
          value.length === 0 ? "hidden" : "",
          "absolute right-14 h-6 w-6 cursor-pointer text-muted-foreground transition-colors hover:text-foreground",
        )}
        onClick={() => {
          onValueChange("");
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }}
      />
      <Button className="btn-square join-item p-0">
        <Search className="h-6 w-6" />
      </Button>
    </HStack>
  );
};
